import { Grid as ThemeUIGrid } from 'theme-ui';

const Grid = (props) => (
  <ThemeUIGrid gap={4} {...props}>
    {props.children}
  </ThemeUIGrid>
);

export default Grid;
